import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import Logo from "../assets/images/front/spryhub-logo.png";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import Image from "../components/elements/Image";
import { classNames } from "../helpers/classNames";
import Button from "../components/form/front/Button";
import User1 from "../assets/images/front/user01.webp";
import useScrollState from "../hooks/useScrollState";
import { useSelector } from "react-redux";
import { useTheme } from "../providers/ThemeProvider";
import userimage from "../assets/images/front/user01.webp";
import Dropdown from "../components/form/Dropdown";
import SearchWithDropdown from "../components/form/front/SearchWithDropdown";
import Select from "../components/form/front/Select";
import { useQuery } from "@tanstack/react-query";
import { organizationFrontList } from "../services/organizationService";
import MultiselectDropdown from "../components/form/MultiselectDropdown";
// import ProfileDropDown from "../components/common/ProfileDropDown";
import { AppsDropdownConnected, TopBar, useSpryAuth } from "spry-apps-dropdown";
import {
  clearKeycloakTokens,
  getPostLogoutRedirectUri,
} from "../helpers/keycloakAuth";
import { ChevronDown, SlidersHorizontal } from "lucide-react";
import useClickOutside from "../hooks/useClickOutside";

const FrontHeader = () => {
  const isScrolled = useScrollState();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isDarkMode, setDarkMode] = useState("off");
  const [keyword, setKeyword] = useState("");
  const [jobType, setJobType] = useState(null);
  const [companyId, setCompanyId] = useState([]);
  const [dateFilter, setDateFilter] = useState(null);
  const [appsOpen, setAppsOpen] = useState(false);
  const [showMobileFilter, setShowMobileFilter] = useState(false);
  const appsButtonRef = useRef(null);
  const menudata = [
    { link: "/", name: "Find Job" },
    { link: "/companies", name: "Companies" },
  ];
  const { session } = useSelector((state) => state?.authProvider);
  const auth = useSpryAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const isJobRoute = location.pathname.startsWith("/job");
  // location.pathname === "/" || location.pathname.startsWith("/job");
  const accessToken = localStorage.getItem("auth_token");
  const isSignedIn =
    Boolean(accessToken) && session?.status === "authorized" && session?.user;
  const dashboardLink =
    session?.user?.role === "admin" ? "/admin/dashboard" : "/dashboard";
  const notificationLink = isSignedIn ? dashboardLink : "/signin";

  const loggedinUser = session?.user || {};

  const fullName =
    [loggedinUser?.firstName, loggedinUser?.lastName]
      .filter(Boolean)
      .join(" ") || "User";
  const firstLetter =
    loggedinUser?.firstName?.charAt(0)?.toUpperCase() ||
    loggedinUser?.email?.charAt(0)?.toUpperCase() ||
    "U";
  const userEmail = loggedinUser?.email || "No email available";

  const profileImage = loggedinUser?.image?.url; // fallback image
  const APPS_API_URL =
    process.env.REACT_APP_SPRY_APPS_API_URL || "https://sprylogin.com/apps-api";
  // Toggle to revert TopBar quickly (set to false to restore custom dropdown)
  const useSpryTopBar = true;
  const handleLogout = () => {
    clearKeycloakTokens();
    localStorage.removeItem("role");
    localStorage.removeItem("auth_provider");
    const postLogoutRedirect = getPostLogoutRedirectUri("/");
    if (auth?.signoutRedirect) {
      auth.signoutRedirect({ post_logout_redirect_uri: postLogoutRedirect });
      return;
    }
    navigate("/");
  };
  const getDateRange = (type) => {
    const now = new Date();

    // Today end time (23:59:59.999)
    const endDate = new Date();
    endDate.setHours(23, 59, 59, 999);

    let startDate = new Date();

    switch (type) {
      case "Past24hrs":
        startDate.setDate(startDate.getDate() - 1);
        startDate.setHours(0, 0, 0, 0);
        break;

      case "PastWeek":
        startDate.setDate(startDate.getDate() - 7);
        startDate.setHours(0, 0, 0, 0);
        break;

      case "PastMonths":
        startDate.setMonth(startDate.getMonth() - 1);
        startDate.setHours(0, 0, 0, 0);
        break;

      default:
        return { startDate: null, endDate: null };
    }

    return {
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
    };
  };
  useEffect(() => {
    if (location.pathname.startsWith("/feed")) {
      setJobType("Post");
    } else if (location.pathname.startsWith("/job")) {
      setJobType("Jobs");
    }
  }, [location.pathname]);
  useEffect(() => {
    var html = document.querySelector("html");
    if (isDarkMode === "on") {
      html.classList.add("dark");
    } else {
      html.classList.remove("dark");
    }
  }, [isDarkMode]);
  useEffect(() => {
    const delay = setTimeout(() => {
      window.dispatchEvent(
        new CustomEvent("global-job-search", {
          detail: { keyword },
        }),
      );
    }, 300);

    return () => clearTimeout(delay);
  }, [keyword]);
  const profileMenu = [
    {
      _id: 1,
      name: "My Profile",
      icon: "fa-regular fa-user",
      link: notificationLink,
    },
    {
      _id: 2,
      name: "Create Company",
      icon: "fa-regular fa-plus",
      link: "/manage-company",
    },
    {
      _id: 3,
      name: "Help",
      icon: "fa-regular fa-circle-question",
      link: "/help",
    },
    ...(isSignedIn
      ? [
          {
            _id: 4,
            name: "Sign out",
            icon: "fa-regular fa-right-from-bracket text-base",
            standout: true,
            click: handleLogout,
          },
        ]
      : []),
  ];

  const jobOptions = [
    { value: "Post", name: "Posts" },
    { value: "Jobs", name: "Jobs" },

    // { value: "Companies", name: "Companies" },
  ];

  const datePosted = [
    { value: "ALL", name: "All Items" },
    { value: "PastMonths", name: "Past Months" },
    { value: "PastWeek", name: "PastWeek" },
    { value: "Past24hrs", name: "Past 24 Hours" },
  ];

  // const company = [
  //   { value: "Turing", name: "Turing" },
  //   { value: "Uplers", name: "Uplers" },
  //   { value: "Accenture in India", name: "Accenture in India" },
  // ];
  const { data: companyData, isLoading: companyLoading } = useQuery({
    queryKey: ["company-list"],
    queryFn: async () => {
      const res = await organizationFrontList({
        limit: 100,
        page: 1,
      });

      if (res?.docs?.status !== 200) return [];

      return res?.docs?.data || [];
    },
  });

  const companyOptions = [
    { value: "ALL", name: "All Items" }, // 👈 Reset option
    ...(companyData?.map((item) => ({
      value: item._id,
      name: item?.content?.en?.title,
    })) || []),
  ];

  const filterRef = useRef(null);
  const toggleButtonRef = useRef(null);

  useClickOutside(filterRef, () => {
    setShowMobileFilter(false);
  }, [toggleButtonRef]);

  useEffect(() => {
    const handleScroll = () => {
      setShowMobileFilter(false);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      {/* ================= HEADER ================= */}
      <motion.header
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: 0.25, ease: "easeInOut" }}
        className={classNames(
          "fixed top-0 left-0 right-0 h-32 flex items-center z-[51] !bg-white border-b border-gray-300",
          isScrolled ? "bg-palatte2 dark:bg-[#0f2d8f]" : "bg-transparent",
        )}
      >
        <div className="w-full px-2 md:px-5 lg:px-0 max-w-full md:max-w-3xl lg:max-w-4xl xls:max-w-7xl 2xl:max-w-5xl 3xl:max-w-6xl mx-auto">
          <div className="flex items-center justify-between gap-3 lg:gap-6 mb-4">
            <Link
              to="/"
              className="min-w-[40px] md:min-w-[140px] max-w-[80px] md:max-w-[140px] w-full"
            >
              <Image
                src={Logo}
                classes="min-w-[40px] md:min-w-[140px] h-auto object-contain"
              />
            </Link>
            {/* {isJobRoute && ( */}
            <div className="w-full hidden md:block">
              <SearchWithDropdown
                placeholder="Search jobs"
                keyword={keyword}
                setKeyword={setKeyword}
                xPlacement="bottom"
                divClasses="shadow-[0_0_2px_rgba(0,0,0,0.16)] dark:text-gray-100 px-3"
                inputClasses="pr-24 placeholder:text-sm"
                icon="fa-light fa-search"
                iconClasses="text-black text-base dark:text-gray-100 pr-1"
              />
            </div>
            {/* )} */}

            <div className="flex items-center justify-between gap-2 md:gap-5 lg:gap-8">
              <div className="flex flex-col items-center">
                <Button
                  buttonIcon="fa-solid fa-briefcase"
                  buttonHasLink
                  buttonLink={"/job"}
                  buttonClasses="bg-transparent hover:bg-transparent text-xl px-1 text-gray-600"
                />
                <span className="text-xs font-medium text-gray-600 -mt-2 hidden md:block">
                  Jobs
                </span>
              </div>

              <div className="flex flex-col items-center">
                <Button
                  buttonIcon="fa-solid fa-newspaper"
                  buttonHasLink
                  buttonLink={"/feed"}
                  buttonClasses="bg-transparent hover:bg-transparent text-xl px-1 text-gray-600"
                />
                <span className="text-xs font-medium text-gray-600 -mt-2 hidden md:block">
                  Posts
                </span>
              </div>

              <div className="flex flex-col items-center gap-0">
                <Button
                  buttonIcon="fa-solid fa-bell"
                  buttonHasLink
                  buttonClasses="bg-transparent hover:bg-transparent text-xl px-1 text-gray-600"
                />
                <span className="text-xs font-medium text-gray-600 -mt-2 hidden md:block">
                  Notifications
                </span>
              </div>

              {useSpryTopBar ? (
                isSignedIn ? (
                  <div className="flex items-center gap-3 flex-row-reverse md:flex-row">
                    <TopBar
                      apiUrl={APPS_API_URL}
                      onSignOut={handleLogout}
                      getAuthToken={() => auth.user?.access_token || null}
                      showAppsDropdown={false}
                      showProfileMenu
                      appsRefetchInterval={30000}
                      appsCacheTime={30000}
                      profileRefetchInterval={5 * 60 * 1000}
                      profileCacheTime={5 * 60 * 1000}
                    />
                    <button
                      ref={appsButtonRef}
                      type="button"
                      onClick={() => setAppsOpen((prev) => !prev)}
                      className="transition"
                      aria-label="Apps"
                    >
                      <i className="fa-solid fa-grid text-lg text-gray-600" />
                    </button>
                    <AppsDropdownConnected
                      apiUrl={APPS_API_URL}
                      open={appsOpen}
                      onClose={() => setAppsOpen(false)}
                      buttonRef={appsButtonRef}
                      refetchInterval={30000}
                      cacheTime={30000}
                    />
                  </div>
                ) : (
                  <Button
                    buttonLabel="Sign In"
                    buttonHasLink
                    buttonLink="/signin"
                    buttonIcon="fa-regular fa-right-to-bracket"
                    buttonIconPosition="right"
                    buttonClasses="bg-palatte h-9 rounded-full px-4 hover:bg-transparent border border-palatte group hover:text-palatte transition-all duration-200 shadow-sm hover:shadow w-28"
                    buttonLabelClasses="text-sm text-white capitalize group-hover:text-palatte font-semibold"
                  />
                )
              ) : (
                <Dropdown
                  data={profileMenu}
                  xPlacement="bottomRight"
                  dropdownContainer="w-72"
                  buttonClasses="p-0 border-0"
                  variantClass="mt-4"
                  itemclasses="last:border-b-2 "
                  ProfileSection={
                    <div className="flex items-center gap-3">
                      {profileImage ? (
                        <img
                          src={profileImage}
                          alt={fullName}
                          className="w-10 h-12 rounded-full object-cover"
                        />
                      ) : (
                        <div className="w-12 h-12 rounded-full bg-palatte flex items-center justify-center text-white font-semibold text-lg">
                          {firstLetter}
                        </div>
                      )}
                      <div>
                        <p className="text-sm font-semibold text-gray-800">
                          {fullName}
                        </p>
                        <p className="text-xs text-gray-500">{userEmail}</p>
                      </div>
                    </div>
                  }
                  button={
                    <div className="flex flex-col items-center gap-2 cursor-pointer flex-shrink-0">
                      {profileImage ? (
                        <img
                          src={profileImage}
                          alt={fullName}
                          className="w-9 h-9 rounded-full object-cover border"
                        />
                      ) : (
                        <div className="w-9 h-9 rounded-full bg-palatte flex items-center justify-center text-white font-semibold text-sm">
                          {firstLetter}
                        </div>
                      )}
                      <span className="text-xs font-medium text-gray-600 -mt-2 flex items-center gap-1">
                        {fullName}
                        <ChevronDown size={12} />
                      </span>
                    </div>
                  }
                />
              )}
            </div>
          </div>
          <div className="flex md:hidden items-center justify-between gap-3 relative">
            <div className="w-full">
              <SearchWithDropdown
                placeholder="Search jobs"
                keyword={keyword}
                setKeyword={setKeyword}
                xPlacement="bottom"
                divClasses="shadow-[0_0_2px_rgba(0,0,0,0.16)] dark:text-gray-100 px-3"
                inputClasses="pr-24 placeholder:text-sm"
                icon="fa-light fa-search"
                iconClasses="text-black text-base dark:text-gray-100 pr-1"
              />
            </div>

            <div
              ref={toggleButtonRef}
              onClick={() => {
                setShowMobileFilter(!showMobileFilter);
              }}
              className="p-2 rounded-full shadow-[0_0_2px_rgba(0,0,0,0.16)]"
            >
              <SlidersHorizontal size={18} />
            </div>
          </div>

          {/* <div className="flex gap-3"> */}

          <div
            ref={filterRef}
            className={classNames(
              `absolute left-0 right-0 mt-6 md:mt-0 bg-white shadow-lg md:!shadow-none p-4 md:p-0 flex flex-col md:flex-row gap-3 transition-all md:transition-none duration-300 origin-top md:origin-center md:relative`,
              showMobileFilter
                ? "opacity-100 scale-y-100 translate-y-0"
                : "opacity-0 scale-y-95 -translate-y-2  pointer-events-none",
              "md:!opacity-100 md:!scale-y-100 md:!translate-y-0 md:!pointer-events-auto",
            )}
          >
            <div className="w-full md:w-[20%]">
              <Select
                placeholder="Jobs"
                dropdownData={jobOptions}
                selectedValue={jobType}
                onChange={(value) => {
                  setJobType(value);

                  if (value === "Jobs") {
                    navigate("/job");
                  }

                  if (value === "Post") {
                    navigate("/post");
                  }
                }}
                xPlacement="bottom-right"
                dropdownClass="bg-white w-full"
                dropdownButtonClass="shadow-sm dark:border-gray-700 dark:bg-gray-700 h-9 !border-gray-500 rounded-full bg-palatte !text-white font-bold"
                selectPlaceholder="text-white"
                selectDropdownIcon={"text-white"}
              />
            </div>
            {isJobRoute && (
              <>
                <div className="w-full md:w-[20%]">
                  <Select
                    placeholder="Date Posted"
                    dropdownData={datePosted}
                    selectedValue={dateFilter}
                    onChange={(value) => {
                      if (value === "ALL") {
                        setDateFilter(null);
                      } else {
                        setDateFilter(value);
                      }
                    }}
                    xPlacement="bottom-right"
                    dropdownClass="bg-white w-full"
                    dropdownButtonClass="shadow-sm dark:border-gray-700 dark:bg-gray-700 h-9 rounded-full shadow-[0_0_2px_rgba(0,0,0,0.16)]"
                  />
                </div>
                <div className="w-full md:w-[20%]">
                  <MultiselectDropdown
                    dropdownData={companyOptions}
                    values={companyId}
                    onChange={(selectedValues) => {
                      if (selectedValues.includes("ALL")) {
                        setCompanyId([]); // 🔥 clear all
                      } else {
                        setCompanyId(selectedValues);
                      }
                    }}
                    xPlacement="bottom-end"
                    type="select"
                    buttonPlaceholder="Company"
                    dropdownButtonClass="shadow-sm dark:border-gray-700 dark:bg-gray-700 h-9 shadow-[0_0_2px_rgba(0,0,0,0.16)] rounded-full bg-white text-black"
                    // isSearch
                    loading={companyLoading}
                  />
                </div>
                <div className="">
                  <Button
                    buttonLabel="Search"
                    buttonFunction={() => {
                      const { startDate, endDate } = getDateRange(dateFilter);

                      window.dispatchEvent(
                        new CustomEvent("global-job-search", {
                          detail: {
                            keyword,
                            startDate,
                            endDate,
                            companyId,
                          },
                        }),
                      );
                    }}
                    buttonClasses="bg-white text-palatte2 hover:bg-transparent hover:text-white px-6 h-9 rounded-full border border-palatte2/50 hover:bg-palatte"
                    buttonLabelClasses="font-semibold"
                  />
                </div>
              </>
            )}
          </div>
        </div>
      </motion.header>

      {/* ================= SIDEBAR ================= */}
      <AnimatePresence>
        {isSidebarOpen && (
          <>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 0.5 }}
              exit={{ opacity: 0 }}
              onClick={() => setIsSidebarOpen(false)}
              className="fixed inset-0 bg-black z-40 overflow-hidden"
            />
            <motion.aside
              initial={{ x: "-100%" }}
              animate={{ x: 0 }}
              exit={{ x: "-100%" }}
              transition={{ duration: 0.3, ease: "easeInOut" }}
              className="fixed top-0 left-0 w-72 h-full bg-palatte2 z-[51] p-6 flex flex-col"
            >
              <div className="flex items-center justify-between mb-8">
                <Image src={Logo} classes="object-contain h-10" />
              </div>

              {/* MENU */}
              <nav className="flex flex-col gap-4">
                {menudata.map((item, index) => (
                  <NavLink
                    key={index}
                    to={item.link}
                    onClick={() => setIsSidebarOpen(false)}
                    className={({ isActive }) =>
                      classNames(
                        "text-lg font-semibold transition-all",
                        isActive ? "text-white" : "text-white",
                      )
                    }
                  >
                    {item.name}
                  </NavLink>
                ))}
              </nav>

              {/* USER */}
              <div className="mt-auto flex items-center gap-3 pt-6 border-t border-white/20">
                <div className="w-12 aspect-square rounded-full overflow-hidden">
                  {profileImage ? (
                    <Image src={profileImage} classes="object-cover" />
                  ) : (
                    <div className="w-full h-full bg-white text-palatte2 flex items-center justify-center font-semibold text-lg">
                      {firstLetter}
                    </div>
                  )}
                </div>
                <span className="text-white font-medium">Profile</span>
              </div>
            </motion.aside>
          </>
        )}
      </AnimatePresence>
    </>
  );
};

export default FrontHeader;
